  var hostname = window.location.hostname;
  var pathname = window.location.pathname;

  var formID = null;

  if (hostname === "regencychess.ie") {
    formID = "U53pH5";
  } else if (hostname === "regencychess.fr") {
    formID = "VCTeET";
  } else if (hostname === "regencychess.de") {
    formID = "X2qkrk";
  } else if (hostname === "regencychess.nl") {
    formID = "XDXcF5";
  } else if (hostname === "regencychess.be" && pathname.startsWith("/fr/")) {
    formID = "WfJQKf";
  } else if (hostname === "regencychess.be" && pathname.startsWith("/de/")) {
    formID = "VaJg8P";
  } else if (hostname === "regencychess.be") {
    formID = "SaKxD2";
  } else if (hostname === "regencychess.co.nz") {
    formID = "WMEnV5";
  } else if (hostname === "regencychess.ae" && pathname.startsWith("/ar/")) {
    formID = "WDH8it";
  } else if (hostname === "regencychess.ae") {
    formID = "TsdSTp";
  } else if (hostname === "regencychess.es") {
    formID = "Y8Vevy";
  } else if (hostname === "regencychess.pl") {
    formID = "UxftjK";
  }

  function openKlaviyoForm() {
    console.log(hostname);
    console.log(pathname);
    if (formID) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formID]);
    } else {
      console.log("No matching formID found for the current hostname.");
    }
  }